import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ image, image2 }) => {
  const lang = window.location.href.includes('/fr') ? 'fr' : 'eng';
  const byText =
    lang === 'fr' ? 'par Wealth Finance - FZCO' : 'by Wealth Finance - FZCO';

  return (
    <div className="logo" style={{ position: 'relative' }}>
      <Link to={process.env.PUBLIC_URL + `/${lang}`}>
        <img
          className="logo-light"
          src={process.env.PUBLIC_URL + image}
          alt="Corporate Logo"
        />
        <img
          className="logo-dark"
          src={process.env.PUBLIC_URL + image2}
          alt="Corporate Logo"
        />
      </Link>
      <div
        style={{
          position: 'absolute',
          bottom: '2px',
          right: '0',
          fontSize: '12px',
          color: '#999',
          textAlign: 'right',
          width: '100%'
        }}
      >
        {byText}
      </div>
    </div>
  );
};
Logo.propTypes = {
  image: PropTypes.string
};

export default Logo;
